import AdminRole from "../components/AdminRole";
import useAdminRole from "../hooks/useAdminRole";

function AdminRolePage(){
    const UseAdminRole = useAdminRole();
    return<AdminRole {...UseAdminRole}/>
}
export default AdminRolePage;